import { dynamic } from 'sierra-client/utils/dynamic'

export const EmojiDetector = dynamic(() => import('sierra-client/editor/emoji-detector-implementation'))
